import type { SaveBonus, SaveCurrency } from '@/state/playerStore';

export type CurrencyState = SaveCurrency;
export type BonusState = SaveBonus;

export interface ShieldSessionState {
  shieldsActive: number;
  shieldsRemaining: number;
}

export interface ScoreBoostSessionState {
  isActive: boolean;
  level: number;
  multiplier: number;
  rawScore: number;
  boostedScore: number;
}

export interface GoldEarnedResult {
  baseGold: number;
  scoreBonus: number;
  comboBonus: number;
  personalBestBonus: number;
  totalGold: number;
}

export interface PurchaseResult {
  success: boolean;
  newLevel?: number;
  newCount?: number;
  goldSpent: number;
  error?: string;
}

export interface GoldAdResult {
  success: boolean;
  goldEarned: number;
  error?: string;
}

export interface UpgradeDefinition {
  id: 'scoreBoost';
  name: string;
  description: string;
  maxLevel: number;
  costs: number[];
  cumulativeBoost: number[];
}

export interface ComboShieldDefinition {
  costPerShield: number;
  bulkCost: number;
  bulkAmount: number;
  maxShields: number;
  maxPerGame: number;
}

export interface BonusSettings {
  tokensPerAd: number;
  bonusMultiplier: number;
  maxTokens: number;
  adCooldownMinutes: number;
}

export interface AdWatchResult {
  success: boolean;
  tokensEarned: number;
  error?: string;
}

export interface GameSessionBonus {
  isActive: boolean;
  multiplier: number;
  tokensUsed: number;
  originalScore: number;
  bonusScore: number;
}

export const INITIAL_SHIELD_SESSION: ShieldSessionState = {
  shieldsActive: 0,
  shieldsRemaining: 0,
};

export const INITIAL_SCORE_BOOST_SESSION: ScoreBoostSessionState = {
  isActive: false,
  level: 0,
  multiplier: 0,
  rawScore: 0,
  boostedScore: 0,
};

export const INITIAL_SESSION_BONUS: GameSessionBonus = {
  isActive: false,
  multiplier: 1,
  tokensUsed: 0,
  originalScore: 0,
  bonusScore: 0,
};

export const DEFAULT_BONUS_SETTINGS: BonusSettings = {
  tokensPerAd: 3,
  bonusMultiplier: 1.5,
  maxTokens: 9,
  adCooldownMinutes: 1,
};
